<template>
  <aside class="scroll ver">
    <img v-if="logoPath" :src="logoPath" alt="" class="logo p-3">

    <h3>{{ configAttrs.businessName }}</h3>

    <TransitionExpand>
      <div v-show="attrsShown" class="pl-3">
        <div class="mb-2">
          <p class="mb-0">Place ID:</p>
          <small>{{ configAttrs.businessPlaceId }}</small>
        </div>
      </div>
    </TransitionExpand>

    <a href="#" class="attributes-show-toggle" @click.prevent="toggleAttrsShown">
      <i :class="['far fa-fw fa-angle-down', { 'fa-rotate-180': attrsShown }]" />
    </a>

    <h5 class="mb-2 pl-3">Search Terms:</h5>
    <SearchTerm
      v-for="searchTerm in searchTerms"
      :key="searchTerm.id"
      :search-term="searchTerm"
      :is-current="searchTerm === currentSearchTerm"
      @changeCurrentSearchTerm="$emit('changeCurrentSearchTerm', $event)" />
  </aside>
</template>

<script>
import TransitionExpand from 'vue_widgets/components/transition_expand'
import SearchTerm from './config_aside/search_term'

export default {
  components: { TransitionExpand, SearchTerm },
  props: {
    logoPath: { type: String },
    configAttrs: { type: Object, required: true },
    searchTerms: { type: Array, required: true },
    currentSearchTerm: { type: Object, required: true }
  },
  data() {
    return {
      attrsShown: false
    }
  },
  methods: {
    toggleAttrsShown() {
      this.attrsShown = !this.attrsShown
    }
  }
}
</script>
